/* gr-bundle-rewards.js — Gamified Bundle Rewards behavior.
 *
 * State per card: { handle, qty, grind, product, variantId, price, sellingPlans }
 * Reward tiers:
 *   1 bag  = no reward
 *   2 bags = discount %
 *   3 bags = FREE MUG
 *   4+     = FREE MUG + MYSTERY GIFT
 */

(() => {
  const root = document.querySelector('.grr');
  if (!root) return;

  const discountPct = parseInt(root.dataset.discountPct, 10) || 10;
  const mugHandle = root.dataset.mugHandle || 'gothrider-mug';
  const mysteryText = root.dataset.mysteryText || 'MYSTERY GIFT';

  // Elements
  const $gaugeFill = root.querySelector('[data-gauge-fill]');
  const $gaugeMsg = root.querySelector('[data-gauge-msg]');
  const $sidebarItems = root.querySelector('[data-sidebar-items]');
  const $sidebarRewards = root.querySelector('[data-sidebar-rewards]');
  const $subtotal = root.querySelector('[data-subtotal]');
  const $discountRow = root.querySelector('[data-discount-row]');
  const $discountAmt = root.querySelector('[data-discount-amt]');
  const $subRow = root.querySelector('[data-sub-row]');
  const $total = root.querySelector('[data-total]');
  const $addBtn = root.querySelector('[data-add-btn]');
  const $addLabel = root.querySelector('[data-add-label]');
  const $subCheck = root.querySelector('[data-subscribe-check]');
  const $freqChips = root.querySelector('[data-freq-chips]');

  // Card state: keyed by handle
  var cards = [];
  var milestones = root.querySelectorAll('.grr__milestone');
  var prevTotalBags = 0;

  // ── Init: fetch products ─────────────────────────────────────
  var cardEls = root.querySelectorAll('.grr__card');
  cardEls.forEach(function (el) {
    var handle = el.dataset.handle;
    var card = {
      el: el,
      handle: handle,
      qty: 0,
      grind: 'whole',
      product: null,
      variantId: null,
      price: 0,
      sellingPlans: [],
    };
    cards.push(card);

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        card.product = product;

        // Find the 12oz (340g) variant, or fall back to first available
        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var t = (v.title || '').toLowerCase();
          if (t.indexOf('12') !== -1 || t.indexOf('340') !== -1) {
            variant = v;
            break;
          }
        }
        if (!variant) variant = product.variants[0];

        card.variantId = variant.id;
        card.price = variant.price / 100;

        // Selling plans
        if (product.selling_plan_groups && product.selling_plan_groups.length > 0) {
          product.selling_plan_groups.forEach(function (g) {
            g.selling_plans.forEach(function (sp) {
              card.sellingPlans.push({
                id: sp.id,
                name: sp.name,
              });
            });
          });
        }

        // Update card UI
        var imgContainer = el.querySelector('[data-card-img]');
        var nameEl = el.querySelector('[data-card-name]');
        var priceEl = el.querySelector('[data-card-price]');

        nameEl.textContent = product.title.toUpperCase();
        priceEl.textContent = '$' + card.price.toFixed(2);

        // Set image
        if (product.featured_image) {
          var placeholder = imgContainer.querySelector('.grr__card-img-placeholder');
          if (placeholder) placeholder.remove();
          var img = document.createElement('img');
          img.src = product.featured_image.replace(/\.([a-z]+)$/, '_400x.$1');
          img.alt = product.title;
          img.loading = 'lazy';
          imgContainer.appendChild(img);
        }
      })
      .catch(function (err) {
        console.warn('Failed to load product: ' + handle, err);
      });

    // Grind chips
    el.querySelectorAll('[data-grind-val]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        el.querySelectorAll('[data-grind-val]').forEach(function (c) {
          c.classList.remove('is-active');
        });
        chip.classList.add('is-active');
        card.grind = chip.dataset.grindVal;
        render();
      });
    });

    // Qty stepper
    var $val = el.querySelector('[data-qty-val]');
    el.querySelector('[data-qty-dec]').addEventListener('click', function () {
      if (card.qty > 0) {
        card.qty--;
        $val.textContent = card.qty;
        render();
      }
    });
    el.querySelector('[data-qty-inc]').addEventListener('click', function () {
      card.qty++;
      $val.textContent = card.qty;
      render();
    });
  });

  // ── Subscribe toggle ────────────────────────────────────────
  $subCheck.addEventListener('change', function () {
    $freqChips.hidden = !$subCheck.checked;
    render();
  });

  // Freq chips
  root.querySelectorAll('[data-freq-val]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      root.querySelectorAll('[data-freq-val]').forEach(function (c) {
        c.classList.remove('is-active');
      });
      chip.classList.add('is-active');
      render();
    });
  });

  // ── Render ──────────────────────────────────────────────────
  function render() {
    var totalBags = 0;
    var subtotal = 0;

    cards.forEach(function (c) {
      totalBags += c.qty;
      subtotal += c.qty * c.price;
      c.el.classList.toggle('is-active', c.qty > 0);
    });

    // Gauge fill
    var maxMilestone = 4;
    var fillPct = Math.min((totalBags / maxMilestone) * 100, 100);
    $gaugeFill.style.width = fillPct + '%';

    // Milestones
    milestones.forEach(function (m) {
      var level = parseInt(m.dataset.milestone, 10);
      var wasReached = m.classList.contains('is-reached');
      var isReached = totalBags >= level;
      m.classList.toggle('is-reached', isReached);

      // Animate on newly reached
      if (isReached && !wasReached) {
        m.classList.add('is-just-unlocked');
        setTimeout(function () { m.classList.remove('is-just-unlocked'); }, 700);
      }
    });

    // Gauge message
    updateGaugeMsg(totalBags);
    prevTotalBags = totalBags;

    // Sidebar items
    renderSidebarItems(totalBags);

    // Sidebar rewards
    renderSidebarRewards(totalBags);

    // Totals
    var discount = 0;
    if (totalBags >= 2) {
      discount = subtotal * (discountPct / 100);
    }

    var subSaving = 0;
    var afterDiscount = subtotal - discount;
    if ($subCheck.checked) {
      subSaving = afterDiscount * 0.15;
    }

    var grandTotal = afterDiscount - subSaving;
    if (grandTotal < 0) grandTotal = 0;

    $subtotal.textContent = '$' + subtotal.toFixed(2);

    if (discount > 0) {
      $discountRow.hidden = false;
      $discountAmt.textContent = '-$' + discount.toFixed(2);
    } else {
      $discountRow.hidden = true;
    }

    if ($subCheck.checked && subSaving > 0) {
      $subRow.hidden = false;
    } else {
      $subRow.hidden = true;
    }

    $total.textContent = '$' + grandTotal.toFixed(2);

    // CTA
    if (totalBags === 0) {
      $addBtn.disabled = true;
      $addLabel.textContent = 'ADD BUNDLE TO CART';
    } else {
      $addBtn.disabled = false;
      $addLabel.textContent = 'ADD BUNDLE TO CART \u00B7 $' + grandTotal.toFixed(2);
    }
  }

  function updateGaugeMsg(bags) {
    if (bags === 0) {
      $gaugeMsg.textContent = 'Add a coffee to get started!';
      $gaugeMsg.classList.remove('is-unlocked');
    } else if (bags === 1) {
      $gaugeMsg.textContent = 'Add 1 more to unlock ' + discountPct + '% OFF!';
      $gaugeMsg.classList.remove('is-unlocked');
    } else if (bags === 2) {
      if (prevTotalBags < 2) {
        $gaugeMsg.textContent = '\uD83C\uDF89 ' + discountPct + '% DISCOUNT UNLOCKED! Add 1 more for a FREE MUG!';
        $gaugeMsg.classList.add('is-unlocked');
      } else {
        $gaugeMsg.textContent = 'Add 1 more to unlock a FREE MUG!';
        $gaugeMsg.classList.remove('is-unlocked');
      }
    } else if (bags === 3) {
      if (prevTotalBags < 3) {
        $gaugeMsg.textContent = '\uD83C\uDF89 FREE MUG UNLOCKED! Add 1 more for a ' + mysteryText + '!';
        $gaugeMsg.classList.add('is-unlocked');
      } else {
        $gaugeMsg.textContent = 'Add 1 more to unlock a ' + mysteryText + '!';
        $gaugeMsg.classList.remove('is-unlocked');
      }
    } else {
      if (prevTotalBags < 4) {
        $gaugeMsg.textContent = '\uD83C\uDF89 ' + mysteryText + ' UNLOCKED! Maximum rewards achieved!';
        $gaugeMsg.classList.add('is-unlocked');
      } else {
        $gaugeMsg.textContent = '\uD83C\uDF89 All rewards unlocked! Maximum value bundle!';
        $gaugeMsg.classList.add('is-unlocked');
      }
    }

    // Update mobile toggle text
    var toggleText = root.querySelector('[data-sidebar-toggle-text]');
    if (toggleText) {
      var tp = 0;
      cards.forEach(function (c) { tp += (c.qty || 0) * (c.price || 0); });
      toggleText.textContent = bags + ' bag' + (bags !== 1 ? 's' : '') + ' · $' + tp.toFixed(2);
    }
  }

  function renderSidebarItems(totalBags) {
    // Clear
    while ($sidebarItems.firstChild) {
      $sidebarItems.removeChild($sidebarItems.firstChild);
    }

    if (totalBags === 0) {
      var empty = document.createElement('div');
      empty.className = 'grr__sidebar-empty';
      empty.textContent = 'No coffees selected yet.';
      $sidebarItems.appendChild(empty);
      return;
    }

    cards.forEach(function (c) {
      if (c.qty === 0) return;
      var row = document.createElement('div');
      row.className = 'grr__sidebar-item';

      var info = document.createElement('div');
      info.className = 'grr__sidebar-item-info';

      var name = document.createElement('div');
      name.className = 'grr__sidebar-item-name';
      name.textContent = (c.product ? c.product.title.toUpperCase() : c.handle.replace(/-/g, ' ').toUpperCase()) + ' x' + c.qty;

      var meta = document.createElement('div');
      meta.className = 'grr__sidebar-item-meta';
      meta.textContent = c.grind === 'whole' ? 'Whole Bean' : 'Ground';

      info.appendChild(name);
      info.appendChild(meta);

      var price = document.createElement('div');
      price.className = 'grr__sidebar-item-price';
      price.textContent = '$' + (c.qty * c.price).toFixed(2);

      row.appendChild(info);
      row.appendChild(price);
      $sidebarItems.appendChild(row);
    });
  }

  function renderSidebarRewards(totalBags) {
    while ($sidebarRewards.firstChild) {
      $sidebarRewards.removeChild($sidebarRewards.firstChild);
    }

    // Read reward tiers from JSON data
    var tiersEl = document.querySelector('[data-reward-tiers]');
    var tiers = [];
    if (tiersEl) {
      try { tiers = JSON.parse(tiersEl.textContent).filter(Boolean); } catch (e) {}
    }

    if (tiers.length) {
      tiers.forEach(function (tier) {
        if (totalBags >= tier.bags) {
          var label = tier.label + ' UNLOCKED';
          if (tier.free_product) {
            var pName = typeof tier.free_product === 'object' ? tier.free_product.title : '';
            if (pName) label = tier.label + ' UNLOCKED (' + pName + ')';
          }
          addRewardRow($sidebarRewards, label);
        }
      });
    } else {
      // Fallback if no reward tier blocks
      if (totalBags >= 2) addRewardRow($sidebarRewards, discountPct + '% DISCOUNT UNLOCKED');
      if (totalBags >= 3) addRewardRow($sidebarRewards, 'FREE MUG UNLOCKED');
      if (totalBags >= 4) addRewardRow($sidebarRewards, mysteryText + ' UNLOCKED');
    }
  }

  function addRewardRow(parent, text) {
    var row = document.createElement('div');
    row.className = 'grr__sidebar-reward';

    var check = document.createElement('div');
    check.className = 'grr__sidebar-reward-check';
    check.textContent = '\u2713';

    var label = document.createElement('span');
    label.textContent = text + ' UNLOCKED';

    row.appendChild(check);
    row.appendChild(label);
    parent.appendChild(row);
  }

  // ── Add to cart ─────────────────────────────────────────────
  $addBtn.addEventListener('click', async function () {
    if ($addBtn.disabled) return;
    $addBtn.disabled = true;
    $addLabel.textContent = 'ADDING\u2026';

    var totalBags = 0;
    cards.forEach(function (c) { totalBags += c.qty; });

    // Resolve selected frequency
    var selectedFreq = '';
    if ($subCheck.checked) {
      var activeFreq = root.querySelector('[data-freq-val].is-active');
      selectedFreq = activeFreq ? activeFreq.dataset.freqVal : '4w';
    }

    // Build items array
    var items = [];
    cards.forEach(function (c) {
      if (c.qty === 0) return;
      var item = {
        id: c.variantId,
        quantity: c.qty,
        properties: {
          Grind: c.grind === 'whole' ? 'Whole Bean' : 'Ground',
          _bundle_rewards: 'true',
        },
      };

      // Attach selling plan if subscribed
      if ($subCheck.checked && c.sellingPlans.length > 0) {
        var plan = matchSellingPlan(c.sellingPlans, selectedFreq);
        if (plan) {
          item.selling_plan = plan.id;
        }
      }

      items.push(item);
    });

    // Add free products from unlocked reward tiers
    var tiersEl = document.querySelector('[data-reward-tiers]');
    if (tiersEl) {
      try {
        var tiers = JSON.parse(tiersEl.textContent).filter(Boolean);
        for (var t = 0; t < tiers.length; t++) {
          var tier = tiers[t];
          if (totalBags >= tier.bags && tier.free_product) {
            var handle = typeof tier.free_product === 'string' ? tier.free_product : (tier.free_product.handle || '');
            if (!handle) continue;
            try {
              var freeProduct = await fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
              if (freeProduct && freeProduct.variants && freeProduct.variants[0]) {
                items.push({
                  id: freeProduct.variants[0].id,
                  quantity: 1,
                  properties: {
                    'Bundle Reward': tier.label || 'FREE GIFT',
                    'Discount Type': 'free_gift',
                  },
                });
              }
            } catch (e) {
              console.warn('Could not add free product for tier:', tier.label, e);
            }
          }
        }
      } catch (e) {
        console.warn('Could not parse reward tiers:', e);
      }
    }

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      if (!res.ok) throw new Error('Cart add failed: ' + res.status);

      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new CustomEvent('gr:cart:open'));

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.open) cartDrawer.open();
    } catch (err) {
      console.error('Bundle add error:', err);
      $addLabel.textContent = 'ERROR \u2014 TRY AGAIN';
      $addBtn.disabled = false;
      return;
    }

    $addLabel.textContent = 'ADDED!';
    setTimeout(function () {
      $addBtn.disabled = false;
      render();
    }, 1500);
  });

  // Match selling plan by frequency key
  function matchSellingPlan(plans, freqKey) {
    var freqMap = {
      '2w': ['2 week', 'every 2', '14 day', 'biweekly'],
      '4w': ['4 week', 'every 4', '30 day', 'monthly', 'every month'],
      '8w': ['8 week', 'every 8', '60 day', '2 month'],
    };
    var keywords = freqMap[freqKey] || freqMap['4w'];

    for (var i = 0; i < plans.length; i++) {
      var name = plans[i].name.toLowerCase();
      for (var k = 0; k < keywords.length; k++) {
        if (name.indexOf(keywords[k]) !== -1) {
          return plans[i];
        }
      }
    }
    // Fallback: return first plan
    return plans[0] || null;
  }

  // ─── Mobile CTA bar ─────────────────────────────────────────
  var $mobileBags = root.querySelector('[data-mobile-bags]');
  var $mobileTotal = root.querySelector('[data-mobile-total]');
  var $mobileAdd = root.querySelector('[data-mobile-add]');

  if ($mobileAdd) {
    $mobileAdd.addEventListener('click', function () {
      // Trigger the main add button
      var mainAdd = root.querySelector('[data-add-btn]');
      if (mainAdd && !mainAdd.disabled) mainAdd.click();
    });
  }

  // Patch render to update mobile CTA
  var _origRender = render;
  render = function () {
    _origRender();
    var total = 0; var subtotal = 0;
    cards.forEach(function (c) { total += c.qty || 0; subtotal += (c.qty || 0) * (c.price || 0); });
    var discount = total >= 2 ? subtotal * (discountPct / 100) : 0;
    var subCheck = root.querySelector('[data-subscribe-check]');
    var isSubscribed = subCheck && subCheck.checked;
    var subDiscount = isSubscribed ? (subtotal - discount) * 0.15 : 0;
    var finalPrice = subtotal - discount - subDiscount;

    if ($mobileBags) $mobileBags.textContent = total + ' bag' + (total !== 1 ? 's' : '');
    if ($mobileTotal) {
      if (discount > 0 || subDiscount > 0) {
        $mobileTotal.textContent = '$' + finalPrice.toFixed(2) + ' (save $' + (discount + subDiscount).toFixed(2) + ')';
      } else {
        $mobileTotal.textContent = '$' + subtotal.toFixed(2);
      }
    }
    if ($mobileAdd) {
      $mobileAdd.disabled = total === 0;
      $mobileAdd.textContent = total === 0 ? 'ADD TO CART' : 'ADD TO CART · $' + finalPrice.toFixed(2);
    }
  };

  // Initial render
  render();
})();
